import PayoutCoverageAndDocuments from "./PayoutCoverageAndDocuments";

export default PayoutCoverageAndDocuments;
